import { jsx as _jsx } from "react/jsx-runtime";
export const PageTitle = ({ children }) => {
    return (_jsx("div", Object.assign({ className: "page-title" }, { children: _jsx("h2", Object.assign({ className: "page-title__title" }, { children: children })) })));
};
